export type AddressMessages = {
  addressBrazilOption: string;
};

export const ADRESS_MESSAGES: AddressMessages = {
  addressBrazilOption: "Brasil",
};
